import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { ModalController, NavController, IonicModule } from '@ionic/angular';
import { merge } from 'lodash';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCModalLimitRateComponent = class UiCModalLimitRateComponent {
    constructor(modalController, navCtrl) {
        this.modalController = modalController;
        this.navCtrl = navCtrl;
    }
    ngOnInit() {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.amountDailyLimit = this.response.amountDailyLimit;
        this.amountThirtyLimit = this.response.amountThirtyLimit;
        this.valueDailyLimit = this.response.valueDailyLimit;
        this.valueThirtyLimit = this.response.valueThirtyLimit;
    }
    goTo() {
        this.dismiss();
        this.navCtrl.navigateRoot([this.limitRoute]);
    }
    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            dismissed: true,
        });
        this.notification = { wlTheme: { limitNotification: false } };
        this.layoutConfig = merge(this.config, this.notification);
        localStorage.setItem(`layoutConfig-${this.version}`, JSON.stringify(this.layoutConfig));
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalLimitRateComponent.prototype, "response", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCModalLimitRateComponent.prototype, "config", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalLimitRateComponent.prototype, "limitRoute", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCModalLimitRateComponent.prototype, "version", void 0);
UiCModalLimitRateComponent = __decorate([
    Component({
        selector: 'ui-c-modal-limit-rate',
        template: "<div class=\"ui-c-modal-limit-rate-inner d-flex flex-column justify-content-center align-items-center mt-3\">\n\n  <ion-row>\n    <ion-col size=\"12\" class=\"text-center\">\n      <h2 class=\"header-title font-size-18\">\n        {{ 'LIMITS_RATE.HEADER.ONE' | wlpTranslate }}\n      </h2>\n      <p class=\"lead-text font-size-18\">\n        {{ 'LIMITS_RATE.LEAD_TEXT.ONE' | wlpTranslate }}\n      </p>\n      <h2 class=\"header-title font-size-18\">{{ 'LIMITS_RATE.HEADER.TWO' | wlpTranslate }}</h2>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"content-values\">\n    <ion-col>\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"><strong>{{ 'LIMITS_RATE.LIMITS.VALUE_DAILY_LIMIT' | wlpTranslate\n            }}</strong></ion-col>\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ valueDailyLimit | currency: 'BRL' }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"><strong>{{ 'LIMITS_RATE.LIMITS.VALUE_THIRTY_LIMIT' | wlpTranslate\n            }}</strong></ion-col>\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ valueThirtyLimit | currency: 'BRL' }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"><strong>{{ 'LIMITS_RATE.LIMITS.AMOUNT_DAILY_LIMIT' | wlpTranslate\n            }}</strong></ion-col>\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ amountDailyLimit }}</ion-col>\n      </ion-row>\n\n      <ion-row class=\"w-100\">\n        <ion-col size=\"6\" class=\"bg-primary\"><strong>{{ 'LIMITS_RATE.LIMITS.AMOUNT_THIRTY_LIMIT' | wlpTranslate\n            }}</strong></ion-col>\n        <ion-col size=\"6\" class=\"bg-light text-center\">{{ amountThirtyLimit }}</ion-col>\n      </ion-row>\n    </ion-col>\n  </ion-row>\n\n  <ion-row>\n    <ion-col size=\"12\" class=\"limit-text-two text-center\">\n      <p class=\"lead-text font-size-18\">\n        {{ 'LIMITS_RATE.LEAD_TEXT.TWO' | wlpTranslate }}\n        <span class=\"link-color\" (click)=\"goTo()\">\n          {{'LIMITS_RATE.LEAD_TEXT.THREE' | wlpTranslate }}\n        </span>\n      </p>\n    </ion-col>\n\n    <ion-col size=\"12\" class=\"text-center\">\n      <ion-button data-cy=\"log-modallimiterate-btn\" class=\"ion-button\" (click)=\"dismiss()\">\n        <ion-icon name=\"thumbs-up\" class=\"mr-2\"></ion-icon>\n        <ion-label class=\"mt-1\">{{ 'LIMITS_RATE.BUTTON' | wlpTranslate }}</ion-label>\n      </ion-button>\n    </ion-col>\n  </ion-row>\n\n</div>\n"
    }),
    __metadata("design:paramtypes", [ModalController,
        NavController])
], UiCModalLimitRateComponent);

let UiCModalLimitRateModule = class UiCModalLimitRateModule {
};
UiCModalLimitRateModule = __decorate([
    NgModule({
        declarations: [UiCModalLimitRateComponent],
        imports: [IonicModule, CommonModule, UiBsTranslateModule],
        exports: [UiCModalLimitRateComponent],
    })
], UiCModalLimitRateModule);

export { UiCModalLimitRateComponent, UiCModalLimitRateModule };
//# sourceMappingURL=wlp-ui-c-modal-limit-rate.js.map
